import { buildDefaultMatrixConfig } from '@/components/views/Matrix/classes/IMatrixConfig';
import type IMatrixConfig from '@/components/views/Matrix/classes/IMatrixConfig';
import type { CategoryId, GroupId, RaceId, StationRoleId } from '@/utilities/typealiases';

type StationRoles = { id: StationRoleId; enabled: boolean }[];
type RaceGroupIDs = { id: GroupId; enabled: boolean }[];
type CategoryIDs = { id: CategoryId; enabled: boolean }[];

type StationRolesMap = Map<RaceId, StationRoles>;
type RaceGroupMap = Map<RaceId, RaceGroupIDs>;
type CategoryMap = Map<RaceId, CategoryIDs>;

/**
 * Version 2 of matrix settings.
 * This saves ALL stationroles/racegroups/categories, so we know if something has been added after this was saved to db, while version 1 only saved the enabled ones.
 * This is obsolete, superseded by V3
 */
export class SavedMatrixSettingsV2 {
    static NAME_OF_CLASS = 'SavedMatrixSettingsV2';
    public MatrixConfig: IMatrixConfig;

    public StationRolesMap: StationRolesMap;
    public RaceGroupMap: RaceGroupMap;
    public CategoryMap: CategoryMap;

    public Version = 2;

    public constructor(val?: SavedMatrixSettingsV2) {
        this.StationRolesMap = val?.StationRolesMap ?? new Map<RaceId, StationRoles>();
        this.RaceGroupMap = val?.RaceGroupMap ?? new Map<RaceId, RaceGroupIDs>();
        this.CategoryMap = val?.CategoryMap ?? new Map<RaceId, CategoryIDs>();

        this.MatrixConfig = buildDefaultMatrixConfig(val?.MatrixConfig);

        // Reset the RaceID so we dont have a preselected race
        this.MatrixConfig.RaceIDs = null;
        this.MatrixConfig.RaceKey = null;

        // Reset search so we dont have a saved search
        this.MatrixConfig.SearchString = '';
    }

    public deserialize(json: any): any {
        return JSON.parse(json, (key, value) => {
            // If the key is one of the maps we need to convert the array back to a map
            if (['StationRolesMap', 'RaceGroupMap', 'CategoryMap'].includes(key)) {
                return new Map(value);
            }

            return value;
        });
    }
}
